import { AnalysisCalculation, SerieCategory } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from './root';

export const COMMON_CHART_MESSAGES = defineMessages({
  noData: { id: 'app.common.chart.noData' },
  other: APP_DICTIONARY.other,

  previous: { id: 'app.common.chart.previous' },

  count: { id: 'app.components.chart.count' },

  min: { id: 'app.common.chart.min' },
  max: { id: 'app.common.chart.max' },
  sum: { id: 'app.common.chart.sum' },
  average: { id: 'app.common.chart.avg' },
  percentage: { id: 'app.common.chart.percentage' },

  consumption: APP_DICTIONARY.consumption,

  cost: APP_DICTIONARY.cost,

  costRatio: { id: 'app.common.chart.costRatio' },
  totalCost: { id: 'app.common.chart.totalCost' },

  increase: { id: 'app.common.chart.increase' },
  decrease: { id: 'app.common.chart.decrease' },

  differenceNoPreviousData: { id: 'app.common.chart.differenceNoPreviousData' },
  differenceSameAsAverage: { id: 'app.common.chart.differenceSameAsAverage' },
  differenceSameAsPrevious: { id: 'app.common.chart.differenceSameAsPrevious' },
  differenceWithAverage: { id: 'app.common.chart.differenceWithAverage' },
  differenceWithPrevious: { id: 'app.common.chart.differenceWithPrevious' },

  perUnit: APP_DICTIONARY.unitPrice,
  perM2: { id: 'app.common.chart.per-m2' },

  meteo: { id: 'app.common.chart.meteo' },
  temperatureIn: { id: 'app.common.chart.temperature-in' },
  temperatureOut: { id: 'app.common.chart.temperature-out' },

  providedInvoices: { id: 'app.common.chart.providedInvoices' },
  missingConsumption: { id: 'app.common.chart.missingConsumption' },
  missingInvoice: { id: 'app.common.chart.missingInvoice' },
});

export const CHART_NAME_PARTS = defineMessages({
  [AnalysisCalculation.Average]: { id: 'app.common.chart.avg' },
  [AnalysisCalculation.Max]: { id: 'app.common.chart.max' },
  [AnalysisCalculation.Min]: { id: 'app.common.chart.min' },
  [AnalysisCalculation.SumPerM2]: { id: 'app.common.chart.per-m2' },
  [AnalysisCalculation.SumPerUnit]: APP_DICTIONARY.unitPrice,
  [AnalysisCalculation.Sum]: { id: 'app.common.chart.sum' },
  [AnalysisCalculation.DegreeDays]: { id: 'app.common.chart.degree-days' },

  [SerieCategory.TemperatureOutside]: { id: 'app.common.chart.temperature-out' },
  [SerieCategory.TemperatureInside]: { id: 'app.common.chart.temperature-in' },
  [SerieCategory.Meteo]: { id: 'app.common.chart.meteo' },

  sourceCalculated: { id: 'chart.consumptionSource.calculated' },
  sourceInvoice: { id: 'chart.consumptionSource.invoice' },
  sourceManual: { id: 'chart.consumptionSource.manual' },
  sourceSensor: { id: 'chart.consumptionSource.sensor' },
  sourceEmission: {
    id: 'chart.consumptionSource.emission',
    defaultMessage: 'Emission',
    description: 'Probably unused case',
  },

  serieDefaultTotal: APP_DICTIONARY.total,
});
